import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';

import i18n from 'i18next';
import { toast } from "react-toastify";

import { ClientServices } from '../services/clientServices';
import { makePersistable, stopPersisting } from 'mobx-persist-store';

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id:1,"societyName": "Client 1", "winbizCode": "1844", "validators": "Validator1,Validator3", "consultants": "Consultant1,Consultant2,Consultant3", "currency": "0", "paymentCondition": "1", "language": "0", "corporateName": "Corporate Name 1 ", "addressNo": "141 Elm Drive\nGarden City\nNew York", "postalCode": "11530", "NPA": "1", "country": "UM" },
    { id: 2, "societyName": "Client 2", "winbizCode": "1844", "validators": "Validator1,Validator3", "consultants": "Consultant1,Consultant2,Consultant3", "currency": "0", "paymentCondition": "1", "language": "0", "corporateName": "Corporate Name 1 ", "addressNo": "141 Elm Drive\nGarden City\nNew York", "postalCode": "11530", "NPA": "1", "country": "UM" },
    { id: 3, "societyName": "Client 3", "winbizCode": "1844", "validators": "Validator1,Validator3", "consultants": "Consultant1,Consultant2,Consultant3", "currency": "0", "paymentCondition": "1", "language": "0", "corporateName": "Corporate Name 1 ", "addressNo": "141 Elm Drive\nGarden City\nNew York", "postalCode": "11530", "NPA": "1", "country": "UM" },
    { id: 4, "societyName": "Client 4", "winbizCode": "1844", "validators": "Validator1,Validator3", "consultants": "Consultant1,Consultant2,Consultant3", "currency": "0", "paymentCondition": "1", "language": "0", "corporateName": "Corporate Name 1 ", "addressNo": "141 Elm Drive\nGarden City\nNew York", "postalCode": "11530", "NPA": "1", "country": "UM" },
    { id: 5, "societyName": "Client 5", "winbizCode": "1844", "validators": "Validator1,Validator3", "consultants": "Consultant1,Consultant2,Consultant3", "currency": "0", "paymentCondition": "1", "language": "0", "corporateName": "Corporate Name 1 ", "addressNo": "141 Elm Drive\nGarden City\nNew York", "postalCode": "11530", "NPA": "1", "country": "UM" },

];

export default class ClientsStore {    

    
  rootStore;
  clients = [];
    client = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,


          clients: observable,
          client: observable,
          getAll: action,
          getById: action,
          reset: action,
          save: action,
          remove: action,
          duplicate: action,
          searchClient: action
      });
      makePersistable(this, { name: 'clientsStore', properties: ['config'], storage: window.localStorage });

    }       

    reset = () => {        
        runInAction(() => this.client = {});
    }

    searchClient = async (query) => {
        try {
            var result = ClientServices.search(query);
            return result;
        }
        catch (error) {
            return [];
        }

    }

    remove = async (id) => {
        try {
            const data = await ClientServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("client") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    duplicate = async (id) => {
        try {
            const data = await ClientServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("client") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }


    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await ClientServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("client") })}`);
                });
            } catch (error) { }
        } else {
            try {
                const data = await ClientServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("client") })}`);
                    this.reset();
                });
            } catch (error) { }
        }
    };

    reset = () => {
        runInAction(() => this.client = {});
    }

    setConfig = (prop, c) => {this.config[prop] = c;}

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await ClientServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.clients = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.clients = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await ClientServices.getAll({ page: page,filter:filter,sort:sort });
            runInAction(() => { this.clients = data; })
        }
        catch (error) {
            runInAction(() => { this.clients = []; });
        }
    }

    getById = async (id) => {
        try {
            const data = await ClientServices.getById(id);
            runInAction(() => { this.client = data; });
        } catch (error) {
            runInAction(() => { this.client = {}; })
        }
    };
}